import React, { useEffect, useState } from 'react'
import { useDispatch, useStore } from 'react-redux'
import { Table, Checkbox, Modal, Button } from 'rsuite'
import { getCallerScriptsOfPartner, deleteCallerScriptOfPartner } from '../../redux/actions/caller'
import ModalComponent from '../CommonComponents/Modal'
import CreateCallingScriptComponent from '../CreateCallingScriptComponent'
import LoaderComponent from '../CommonComponents/LoaderComponent'

const CallingScriptList = ({ partnerId, onChangeCallingScriptInfo, callingScripts, onUpdateScript, getScripts, isLoading, isDefaultId, partnerName = '' }) => {
    const { Column, HeaderCell, Cell, Pagination } = Table
    const dispatch = useDispatch();

    const [scripts, setScripts] = useState([]);
    const [checkedKeys, setCheckedKeys] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [backdrop, setBackdrop] = React.useState('static');
    const [scriptId, setScriptId] = useState(null)
    const [onEdit, setOnEdit] = useState(false);
    const [scriptDetailById, setScriptDetailById] = useState({})
    const [isDefaultScript, setIsDefaultScript] = useState(false)
    const [sequenceLimit, setSequenceLimit] = useState(10)
    const [sequencePage, setSequencePage] = useState(1)

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    let checked = false;

    const handleCheck = (id, value, checked) => {
        const keys = checked ? [...checkedKeys, id] : checkedKeys?.filter(item => item !== id);
        setCheckedKeys(keys);
    };

    const onDeleteScript = (scriptId) => {
        setOnEdit(false)
        setOpen(true)
        setScriptId(scriptId)
        const result = scripts.filter((script) => {
            return script.id === scriptId
        })
        if (result[0].isDefault) {
            setIsDefaultScript(true)
        } else {
            setIsDefaultScript(false)
        }
    }

    const onEditScript = (scriptId) => {
        setOnEdit(true)
        setOpen(true)
        setScriptId(scriptId)
        const scriptDetailById = scripts.filter((script) => {
            return script.id == scriptId
        })
        setScriptDetailById(scriptDetailById?.[0])
    }

    const deleteScriptHandler = () => {
        dispatch(deleteCallerScriptOfPartner(partnerId, scriptId)).then((resData) => {
            setScriptId(null)
            setOpen(false)
            getScripts()
        }).catch((err) => {
            setScriptId(null);
            setOpen(false)
        })
    }

    const handleChangeLimit = (limit) => {
        setSequenceLimit(limit);
        setSequencePage(1)
    }

    useEffect(() => {
        setScripts(callingScripts)
    }, [callingScripts])

    const sequencePaginatedData = scripts?.sort((a, b) => {
    }).slice(sequenceLimit * (sequencePage - 1), sequenceLimit * sequencePage)

    return (
        <div className={`partner-preferences border mt-5 bg-white position-relative${isLoading ? ' loading' : ''}`}>
            {isLoading && <LoaderComponent />}
            <Table
                data={sequencePaginatedData}
                autoHeight
                rowHeight={rowData => {
                    return 60;
                }}
            >
                <Column
                    resizable
                    key="title"
                    width={130}
                    bordered={true}
                >
                    <HeaderCell><h4 className='mb-0 fw-bold text-black d-inline'>Script Title</h4></HeaderCell>
                    <Cell className='text-black' dataKey="title" />
                </Column>
                <Column
                    resizable
                    key="script"
                    width={100}
                    bordered={true}
                >
                    <HeaderCell><h4 className='mb-0 fw-bold text-black d-inline'>Script</h4></HeaderCell>
                    <Cell className='text-black' dataKey="script" >
                        {rowData => {
                            let script = rowData?.["script"] === null ? "" : rowData?.["script"].length > 50 ? (rowData?.["script"]?.replace(/(<([^>]+)>)/ig, '')?.slice(0, 50) + "...") : rowData?.["script"]
                            return (
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: script || ''
                                    }}
                                />
                            )
                        }}
                    </Cell>
                </Column>
                <Column
                    resizable
                    key="isDefault"
                    width={100}
                    bordered={true}
                >
                    <HeaderCell><h4 className='mb-0 fw-bold text-black d-inline'>Is Default</h4></HeaderCell>
                    <Cell className='text-black' dataKey="isDefault">{rowData => {
                        return <Checkbox
                            rowData={rowData}
                            checked={rowData["isDefault"] === true ? true : false}
                            onChange={(value, checked) => { handleCheck(rowData?.id, value, checked) }}
                        />
                    }}</Cell>
                </Column>
                {partnerName && (
                    <Column
                        resizable
                        key="isReenablement"
                        width={100}
                        bordered={true}
                    >
                        <HeaderCell><h4 className='mb-0 fw-bold text-black d-inline'>Is Reenablement</h4></HeaderCell>
                        <Cell className='text-black' dataKey="isReenablement">{rowData => {
                            return <Checkbox
                                rowData={rowData}
                                checked={rowData["isReenablement"] === true ? true : false}
                                onChange={(value, checked) => { handleCheck(rowData?.id, value, checked) }}
                            />
                        }}</Cell>
                    </Column>
                )}
                <Column
                    width={250}
                    bordered={true}
                    fixed="right"
                    key="action"
                >
                    <HeaderCell><h4 className='mb-0 fw-bold text-black d-inline'>Action</h4></HeaderCell>
                    <Cell className="table-action" fixed>
                        {rowData => {
                            return (
                                <div className='d-flex justify-content-around'>
                                    <button type="button" className='me-3 pt-2 pb-2 h4 mb-0 fw-bold rounded bg-red text-white width-100' onClick={() => { onDeleteScript(rowData.id) }}>Delete</button>
                                    <button type="button" className='me-3 pt-2 pb-2 h4 mb-0 fw-bold rounded bg-green text-white width-100' onClick={() => { onEditScript(rowData.id) }}>Edit</button>
                                </div>
                            )
                        }}
                    </Cell>
                </Column>
            </Table>
            <div className="calls-table-pagination">
                <Pagination
                    prev
                    next
                    first={true}
                    last={true}
                    maxButtons={5}
                    activePage={sequencePage}
                    showInfo
                    displayLength={sequenceLimit}
                    lengthMenu={[
                        {
                            label: '10',
                            value: 10,
                        },
                        {
                            label: '20',
                            value: 20,
                        },
                        {
                            label: '30',
                            value: 30,
                        },
                        {
                            label: '50',
                            value: 50,
                        },
                        {
                            label: '100',
                            value: 100,
                        },
                    ]}
                    total={scripts?.length}
                    onChangeLength={(limit) => { handleChangeLimit(limit) }}
                    onChangePage={(event) => {
                        setSequencePage(event)
                    }}
                />
            </div>
            <ModalComponent
                backdrop={backdrop}
                open={open}
                handleClose={handleClose}
                modalTitle={onEdit ? '' : `Delete Script`}
                size={`md`}
            >
                {onEdit ? (
                    <>
                        <CreateCallingScriptComponent
                            isFromPartnerManage={true}
                            partnerId={partnerId}
                            isUpdatingScript={true}
                            scriptDetail={scriptDetailById}
                            handleClose={handleClose}
                            onChangeCallingScriptInfo={onChangeCallingScriptInfo}
                            getCallerScriptsOfPartner={getCallerScriptsOfPartner}
                            setScripts={setScripts}
                            onCreateScript={onUpdateScript}
                            isDefaultId={isDefaultId}
                            partnerName={partnerName}
                        />
                    </>
                ) : (
                    <>
                        <h4 className='mb-0 text-black fw-bold m-auto'>
                            {isDefaultScript ?
                                <>
                                    <p className='text-center'>Are you sure you want to delete this script?</p>
                                    <p><em> This is the default script for this partner. Make sure to designate another script as the default.</em></p>
                                </>
                                : 'Are you sure you want to delete this script?'}
                        </h4>
                        <div className='mt-4'>
                            <button className='me-3 pt-2 pb-2 h4 mb-0 fw-bold rounded bg-red text-white width-100' onClick={handleClose}>Cancel</button>
                            <button className='pt-2 pb-2 h4 mb-0 fw-bold rounded btn-green text-white ms-auto width-100' onClick={() => { deleteScriptHandler(scriptId) }}>Ok</button>
                        </div>
                    </>
                )}
            </ModalComponent>
        </div>
    )
}

export default CallingScriptList;
